import algoliasearch from 'algoliasearch/lite';
import React, { Component } from 'react';
import DomainTabs from './components/DomainTabs';
import {
  InstantSearch,
  Index,
  Hits,
  SearchBox,
  Pagination,
  Highlight,
  ClearRefinements,
  RefinementList,
  Configure,
} from 'react-instantsearch-dom';
import PropTypes from 'prop-types';
import './App.css';
import { FaBeer } from 'react-icons/fa';

const searchClient = algoliasearch(
  'GP9OEYS92H',
  'b593d377343dcdf7f0c1a626a1f1664c'
);


// Algolia docs: https://www.algolia.com/doc/guides/building-search-ui/widgets/showcase/react/
class App extends Component {
  render() {
    return (
      <div className="ais-InstantSearch">

        <div className="header">
          <h1>Search Ed-Fi Alliance</h1>
        </div>

        <InstantSearch indexName="Website_Posts" searchClient={searchClient}>

          <div className="search-header">
              <DomainTabs />
              <div className="search-box">
                <SearchBox autofocus="true" />
                <img className="academy-logo" src="https://academy.ed-fi.org/wp-content/themes/joints/assets/images/logos/academy-logo.svg" alt=""/>
              </div>
              <ClearRefinements />
              <RefinementList attribute="categories" />
          </div>

          <div className="search-results">

            <Index indexName="Academy_Lessons">
              <h2>Academy_Lessons</h2>
              <Configure hitsPerPage={4} />
              <Hits hitComponent={Hit} />
            </Index>

            <Index indexName="Academy_Modules">
              <h2>Academy_Modules</h2>
              <Configure hitsPerPage={4} />
              <Hits hitComponent={Hit} />
            </Index>

            <Index indexName="All_Academy_Pages">
              <h2>All_Academy_Pages</h2>
              <Configure hitsPerPage={4} />
              <Hits hitComponent={Hit} />
            </Index>

            {/* <Index indexName="Website_Posts">
              <h2>Website_Posts</h2>
              <Configure hitsPerPage={4} />
              <Hits hitComponent={WebsiteHit} />
            </Index>

            <Index indexName="Website_Searchable_Posts">
              <h2>Website_Searchable_Posts</h2>
              <Configure hitsPerPage={4} />
              <Hits hitComponent={Hit} />
            </Index>

            <Index indexName="Website_Webinars">
              <h2>Website_Webinars</h2>
              <Configure hitsPerPage={4} />
              <Hits hitComponent={Hit} />
            </Index>

            <Index indexName="Website_Pages">
              <h2>Website_Pages</h2>
              <Configure hitsPerPage={4} />
              <Hits hitComponent={Hit} />
            </Index> */}

            <Pagination />
          </div>

        </InstantSearch>
      </div>
    );
  }
}

function Hit(props) {
  console.log(props.hit)
  return (
    <a href={props.hit.permalink} target="_blank">
      <img src={props.hit.image} align="left" alt={props.hit.name} />
      <div className="hit-name">
        <Highlight attribute="post_title" hit={props.hit} />
        <p className="result-category">Category: {props.hit.post_type_label}</p>
      </div>
    </a>
  );
}

// function WebsiteHit(props) {
//   return (
//     <div>
//       <img src={props.hit.images.thumbnail.url} align="left" alt={props.hit.name} />
//       <div className="hit-name">
//         <Highlight attribute="post_title" hit={props.hit} />
//       </div>
//       <div className="hit-description">
//         <Highlight attribute="post_title" hit={props.hit} />
//       </div>
//     </div>
//   );
// }

Hit.propTypes = {
  hit: PropTypes.object.isRequired,
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js